var _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.34,
    y: 130.6,
    width: 65.46,
    height: 171.03,
    rx: 6.24,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.72,280a33.6,33.6,0,0,1,3.42-12.13c-.31-2.79-5.29-4.35-5.29-4.35A92.52,92.52,0,0,1,315,276.57c-1.86,8.4-.31,19.91-.31,19.91H185.61s1.55-11.51-.32-19.91a93.34,93.34,0,0,1-1.86-13.06s-5,1.56-5.29,4.35A33.6,33.6,0,0,1,181.56,280c.62,9.65-2.49,26.13,0,28.62,2.29,2.28,56.9.36,65.68,0,9.58.32,69.19,2.24,71.48,0C321.2,306.12,318.09,289.64,318.72,280Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.33,
    y: 406.33,
    width: 147.48,
    height: 33.62,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 419.32,
    width: 182.63,
    height: 20.63,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.56,302.14h-53a6.76,6.76,0,0,1-6.74-6.74V136.84a6.76,6.76,0,0,1,6.74-6.74h53a6.75,6.75,0,0,1,6.74,6.74V295.4A6.75,6.75,0,0,1,275.56,302.14Zm-53-171a5.75,5.75,0,0,0-5.74,5.74V295.4a5.75,5.75,0,0,0,5.74,5.74h53a5.75,5.75,0,0,0,5.74-5.74V136.84a5.75,5.75,0,0,0-5.74-5.74Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path--inject-7)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.79,310.22c-10.54,0-18.64-.32-19.58-1.26-1.54-1.54-1.24-6.7-.63-15a110.57,110.57,0,0,0,.48-14,33.34,33.34,0,0,0-3.36-11.93.49.49,0,0,1-.06-.29c.35-3.09,5.42-4.71,5.64-4.78a.51.51,0,0,1,.65.45,93.77,93.77,0,0,0,1.85,13c1.63,7.33.67,17.08.39,19.52H314.11c-.28-2.44-1.24-12.19.39-19.52a93.77,93.77,0,0,0,1.85-13A.5.5,0,0,1,317,263c.21.07,5.29,1.69,5.63,4.78a.58.58,0,0,1-.05.29A33.32,33.32,0,0,0,319.21,280a110.71,110.71,0,0,0,.49,14c.61,8.28.91,13.44-.63,15-2.29,2.29-51,.9-71.85.19C236,309.57,215.89,310.22,200.79,310.22Zm-22.13-42.44a33.67,33.67,0,0,1,3.4,12.18,112.44,112.44,0,0,1-.48,14.09c-.47,6.35-1,12.91.34,14.2,1.81,1.53,34.1,1.05,65.3-.1,34.06,1.15,69.24,1.63,71.15.1,1.29-1.29.8-7.85.33-14.2a110.57,110.57,0,0,1-.48-14.09h0a33.67,33.67,0,0,1,3.4-12.18c-.32-1.7-2.83-3-4.32-3.58a94.61,94.61,0,0,1-1.83,12.48c-1.82,8.21-.32,19.62-.3,19.73a.53.53,0,0,1-.12.4.54.54,0,0,1-.38.17H185.61a.52.52,0,0,1-.38-.17.49.49,0,0,1-.12-.4c0-.12,1.52-11.52-.3-19.73A94.61,94.61,0,0,1,183,264.2C181.49,264.78,179,266.08,178.66,267.78Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-2--inject-7)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.82,440.46H175.33a.51.51,0,0,1-.5-.5V406.33a.5.5,0,0,1,.5-.5H322.82a.5.5,0,0,1,.5.5V440A.51.51,0,0,1,322.82,440.46Zm-147-1H322.32V406.83H175.83Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-3--inject-7)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.39,440.46H157.76a.5.5,0,0,1-.5-.5V419.32a.5.5,0,0,1,.5-.5H340.39a.5.5,0,0,1,.5.5V440A.5.5,0,0,1,340.39,440.46Zm-182.13-1H339.89V419.82H158.26Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-4--inject-7)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.44,197.17s-22.11-59-85.41-82-133.34-2.52-190.54,12.57S59,189,68.73,239s57.18,49.65,98.77,96.29,45.57,65.23,106,82.17,130.16-29.51,151-100.47S424.44,197.17,424.44,197.17Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.44,197.17s-22.11-59-85.41-82-133.34-2.52-190.54,12.57S59,189,68.73,239s57.18,49.65,98.77,96.29,45.57,65.23,106,82.17,130.16-29.51,151-100.47S424.44,197.17,424.44,197.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.51,420.85h-3V236a15.35,15.35,0,0,1,15.33-15.33v3A12.34,12.34,0,0,0,200.51,236Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,412.05h-3V109.56a15.35,15.35,0,0,1,15.33-15.34v3a12.35,12.35,0,0,0-12.33,12.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,430.92h-3V230.3a14.24,14.24,0,0,0-14.22-14.22h-3.78v-3h3.78a17.25,17.25,0,0,1,17.22,17.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.34,
    y: 130.6,
    width: 65.46,
    height: 171.03,
    rx: 6.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.56,302.14h-53a6.76,6.76,0,0,1-6.74-6.74V136.84a6.76,6.76,0,0,1,6.74-6.74h53a6.75,6.75,0,0,1,6.74,6.74V295.4A6.75,6.75,0,0,1,275.56,302.14Zm-53-171a5.75,5.75,0,0,0-5.74,5.74V295.4a5.75,5.75,0,0,0,5.74,5.74h53a5.75,5.75,0,0,0,5.74-5.74V136.84a5.75,5.75,0,0,0-5.74-5.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-7)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.34,
    y: 130.6,
    width: 65.46,
    height: 171.03,
    rx: 6.24,
    style: {
      opacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164,427.14h-3V413a5.73,5.73,0,1,0-11.46,0v3.46h-3V413A8.73,8.73,0,1,1,164,413Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.81,427.14h-3V413a8.73,8.73,0,1,1,17.46,0v3.46h-3V413a5.73,5.73,0,1,0-11.46,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.41,427.14h-3V413a8.74,8.74,0,0,1,17.47,0v3.46h-3V413a5.74,5.74,0,0,0-11.47,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.8,427.14h-3V413a5.74,5.74,0,0,0-11.47,0v3.46h-3V413a8.74,8.74,0,0,1,17.47,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.51,
    y: 419.32,
    width: 267.14,
    height: 20.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.64,440.46H115.51a.5.5,0,0,1-.5-.5V419.32a.5.5,0,0,1,.5-.5H382.64a.5.5,0,0,1,.5.5V440A.5.5,0,0,1,382.64,440.46Zm-266.63-1H382.14V419.82H116Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.17,
    y: 413.31,
    width: 10.06,
    height: 6.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.04,
    y: 413.31,
    width: 10.06,
    height: 6.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 413.31,
    width: 10.06,
    height: 6.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.66,
    y: 413.31,
    width: 10.06,
    height: 6.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.29,
    y: 302.93,
    width: 17.58,
    height: 33.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,337.06H240.29a.5.5,0,0,1-.5-.5V302.93a.5.5,0,0,1,.5-.5h17.57a.5.5,0,0,1,.5.5v33.63A.5.5,0,0,1,257.86,337.06Zm-17.07-1h16.57V303.43H240.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.85,
    y: 318.22,
    width: 26.46,
    height: 33.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3,352.34H235.85a.5.5,0,0,1-.5-.5V318.21a.5.5,0,0,1,.5-.5H262.3a.5.5,0,0,1,.5.5v33.63A.5.5,0,0,1,262.3,352.34Zm-26-1H261.8V318.71H236.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.92,
    y: 344.96,
    width: 36.3,
    height: 71.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.22,416.53h-36.3a.51.51,0,0,1-.5-.5V345a.5.5,0,0,1,.5-.5h36.3a.5.5,0,0,1,.5.5V416A.5.5,0,0,1,267.22,416.53Zm-35.8-1h35.3V345.46h-35.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,280a33.6,33.6,0,0,1,3.42-12.13c-.31-2.79-5.29-4.35-5.29-4.35A92.52,92.52,0,0,1,315,276.57c-1.86,8.4-.31,19.91-.31,19.91H185.61s1.55-11.51-.32-19.91a93.34,93.34,0,0,1-1.86-13.06s-5,1.56-5.29,4.35A33.6,33.6,0,0,1,181.56,280c.62,9.65-2.49,26.13,0,28.62,2.29,2.28,56.9.36,65.68,0,9.58.32,69.19,2.24,71.48,0C321.2,306.12,318.09,289.64,318.72,280Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.79,310.22c-10.54,0-18.64-.32-19.58-1.26-1.54-1.54-1.24-6.7-.63-15a110.57,110.57,0,0,0,.48-14,33.34,33.34,0,0,0-3.36-11.93.49.49,0,0,1-.06-.29c.35-3.09,5.42-4.71,5.64-4.78a.51.51,0,0,1,.65.45,93.77,93.77,0,0,0,1.85,13c1.63,7.33.67,17.08.39,19.52H314.11c-.28-2.44-1.24-12.19.39-19.52a93.77,93.77,0,0,0,1.85-13A.5.5,0,0,1,317,263c.21.07,5.29,1.69,5.63,4.78a.58.58,0,0,1-.05.29A33.32,33.32,0,0,0,319.21,280a110.71,110.71,0,0,0,.49,14c.61,8.28.91,13.44-.63,15-2.29,2.29-51,.9-71.85.19C236,309.57,215.89,310.22,200.79,310.22Zm-22.13-42.44a33.67,33.67,0,0,1,3.4,12.18,112.44,112.44,0,0,1-.48,14.09c-.47,6.35-1,12.91.34,14.2,1.81,1.53,34.1,1.05,65.3-.1,34.06,1.15,69.24,1.63,71.15.1,1.29-1.29.8-7.85.33-14.2a110.57,110.57,0,0,1-.48-14.09h0a33.67,33.67,0,0,1,3.4-12.18c-.32-1.7-2.83-3-4.32-3.58a94.61,94.61,0,0,1-1.83,12.48c-1.82,8.21-.32,19.62-.3,19.73a.53.53,0,0,1-.12.4.54.54,0,0,1-.38.17H185.61a.52.52,0,0,1-.38-.17.49.49,0,0,1-.12-.4c0-.12,1.52-11.52-.3-19.73A94.61,94.61,0,0,1,183,264.2C181.49,264.78,179,266.08,178.66,267.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-7)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.72,280a33.6,33.6,0,0,1,3.42-12.13c-.31-2.79-5.29-4.35-5.29-4.35A92.52,92.52,0,0,1,315,276.57c-1.86,8.4-.31,19.91-.31,19.91H185.61s1.55-11.51-.32-19.91a93.34,93.34,0,0,1-1.86-13.06s-5,1.56-5.29,4.35A33.6,33.6,0,0,1,181.56,280c.62,9.65-2.49,26.13,0,28.62,2.29,2.28,56.9.36,65.68,0,9.58.32,69.19,2.24,71.48,0C321.2,306.12,318.09,289.64,318.72,280Z",
    style: {
      opacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,296.48s3.84-7.26,7.36-8.92,111.75,0,111.75,0,7.46-1,9.95,8.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.67,297H185.61a.51.51,0,0,1-.45-.74c.16-.3,4-7.42,7.6-9.13s100.88-.22,112-.05c0,0,7.86-1,10.43,9.3a.53.53,0,0,1-.09.42A.49.49,0,0,1,314.67,297Zm-128.21-1H314c-2.5-8.75-9.16-7.93-9.23-7.93-43.51-.66-109-1.21-111.61,0S187.52,294.12,186.46,296Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.72,267.24s-7.78-.62-11.82,3.73-10.27,9.65-13.69,3.43S168.5,259.47,174.1,257s14.3.62,15.55,3.11A7.05,7.05,0,0,1,188.72,267.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,277.74q-.3,0-.6,0a5.32,5.32,0,0,1-3.95-3.07,7.51,7.51,0,0,1-.33-6.23c1.67-4.94,7.24-10,11.45-11.89,5.91-2.63,14.84.63,16.2,3.35a7.59,7.59,0,0,1-1,7.73.52.52,0,0,1-.39.14c-.08,0-7.59-.55-11.42,3.57C173.26,275.63,170,277.74,167.33,277.74Zm11.55-21.18a11.17,11.17,0,0,0-4.58.88c-4,1.78-9.32,6.6-10.9,11.29a6.56,6.56,0,0,0,.25,5.42,4.31,4.31,0,0,0,3.2,2.56c2.4.3,5.66-1.75,9.68-6.08,3.8-4.08,10.57-4,12-3.9a6.65,6.65,0,0,0,.69-6.42C188.43,258.78,183.59,256.56,178.88,256.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.72,267.24a7.09,7.09,0,0,0,1.09-6.73c-4.71-1.74-10.42.65-15.4,6.73-3.24,4-6.36,7.49-8.43,9.77,3.42,1.2,7.81-2.69,10.92-6C180.94,266.62,188.72,267.24,188.72,267.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.34,277.74a4.63,4.63,0,0,1-1.53-.25.56.56,0,0,1-.32-.35.51.51,0,0,1,.12-.46c2-2.27,5.17-5.8,8.41-9.75,5-6.15,11-8.72,16-6.89a.47.47,0,0,1,.29.28,7.55,7.55,0,0,1-1.2,7.28.52.52,0,0,1-.39.14c-.08,0-7.59-.55-11.42,3.57C173.27,275.62,170,277.74,167.34,277.74Zm-.42-1c2.39.27,5.62-1.78,9.61-6.08,3.8-4.08,10.57-4,12-3.9a6.82,6.82,0,0,0,.91-5.83c-4.51-1.52-10,1-14.62,6.66C171.83,271.18,169,274.44,166.92,276.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.56,267.24s7.78-.62,11.82,3.73,10.26,9.65,13.68,3.43-5.28-14.93-10.88-17.42-14.31.62-15.55,3.11A7.05,7.05,0,0,0,311.56,267.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,277.74c-2.67,0-5.93-2.11-9.94-6.43-3.82-4.12-11.34-3.57-11.41-3.57a.48.48,0,0,1-.39-.14,7.59,7.59,0,0,1-1-7.73c1.36-2.72,10.28-6,16.2-3.35,4.21,1.87,9.78,7,11.45,11.89a7.51,7.51,0,0,1-.33,6.23,5.32,5.32,0,0,1-3.95,3.07Q333.25,277.74,333,277.74Zm-20.3-11c2.35,0,7.83.41,11.1,3.92,4,4.33,7.27,6.37,9.67,6.08a4.31,4.31,0,0,0,3.21-2.56,6.56,6.56,0,0,0,.25-5.42C335.3,264,330,259.22,326,257.44c-5.54-2.47-13.87.81-14.9,2.87a6.63,6.63,0,0,0,.69,6.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.56,267.24a7.07,7.07,0,0,1-1.09-6.73c4.71-1.74,10.42.65,15.4,6.73,3.24,4,6.36,7.49,8.43,9.77-3.42,1.2-7.81-2.69-10.92-6C319.34,266.62,311.56,267.24,311.56,267.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.94,277.74c-2.66,0-5.93-2.12-9.93-6.43-3.83-4.12-11.33-3.57-11.41-3.57a.48.48,0,0,1-.39-.14,7.55,7.55,0,0,1-1.2-7.28.47.47,0,0,1,.29-.28c5-1.83,10.93.74,15.95,6.89,3.24,3.95,6.37,7.48,8.42,9.75a.5.5,0,0,1,.11.46.51.51,0,0,1-.32.35A4.53,4.53,0,0,1,332.94,277.74Zm-20.29-11c2.36,0,7.83.41,11.1,3.92,4,4.3,7.21,6.35,9.61,6.08-2.05-2.26-4.92-5.53-7.88-9.15-4.67-5.71-10.11-8.18-14.62-6.66a6.79,6.79,0,0,0,.91,5.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.33,
    y: 406.33,
    width: 147.48,
    height: 33.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.82,440.46H175.33a.51.51,0,0,1-.5-.5V406.33a.5.5,0,0,1,.5-.5H322.82a.5.5,0,0,1,.5.5V440A.51.51,0,0,1,322.82,440.46Zm-147-1H322.32V406.83H175.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-7)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.33,
    y: 406.33,
    width: 147.48,
    height: 33.62,
    style: {
      opacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 419.32,
    width: 182.63,
    height: 20.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.39,440.46H157.76a.5.5,0,0,1-.5-.5V419.32a.5.5,0,0,1,.5-.5H340.39a.5.5,0,0,1,.5.5V440A.5.5,0,0,1,340.39,440.46Zm-182.13-1H339.89V419.82H158.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-7)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 419.32,
    width: 182.63,
    height: 20.63,
    style: {
      opacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.18,254.83h49.25A6.17,6.17,0,0,1,280.6,261v31.07a0,0,0,0,1,0,0H219a0,0,0,0,1,0,0V261A6.17,6.17,0,0,1,225.18,254.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.6,292.56H219a.5.5,0,0,1-.5-.5V261a6.67,6.67,0,0,1,6.67-6.67h49.25A6.67,6.67,0,0,1,281.1,261v31.06A.5.5,0,0,1,280.6,292.56Zm-61.09-1H280.1V261a5.68,5.68,0,0,0-5.67-5.67H225.18a5.67,5.67,0,0,0-5.67,5.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,149.23h-6.37l-43.51,16.54s8,60.13,11.85,64.23,15.26,7.52,15.26,7.52v20.73H271.1V237.52s11.39-3.42,15.26-7.52,11.84-64.23,11.84-64.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.1,258.75H229.19a.5.5,0,0,1-.5-.5V237.89c-2-.63-11.55-3.76-15.13-7.54-3.94-4.17-11.65-62-12-64.52a.5.5,0,0,1,.32-.53l43.51-16.54.18,0H252a.47.47,0,0,1,.17,0l46.24,16.54a.5.5,0,0,1,.33.53c-.33,2.47-8,60.35-12,64.52-3.57,3.78-13.12,6.91-15.12,7.54v20.36A.5.5,0,0,1,271.1,258.75Zm-41.41-1H270.6V237.52A.49.49,0,0,1,271,237c.11,0,11.3-3.43,15-7.38,3.06-3.24,9.4-46.58,11.66-63.56l-45.78-16.37h-6.2l-43.05,16.36c2.26,17,8.6,60.33,11.66,63.57,3.73,4,14.93,7.35,15,7.38a.5.5,0,0,1,.36.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.19,237.52v20.73H271.1V237.52L255,225.46a7.86,7.86,0,0,0-9.48-.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.1,258.75H229.19a.5.5,0,0,1-.5-.5V237.52a.5.5,0,0,1,.19-.4l16.31-12.33a8.42,8.42,0,0,1,10.09.28l16.12,12.05a.51.51,0,0,1,.2.4v20.73A.5.5,0,0,1,271.1,258.75Zm-41.41-1H270.6v-20l-15.93-11.91a7.4,7.4,0,0,0-8.89-.26l-16.09,12.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,197.06c2.53-15.8,4.58-31.29,4.58-31.29L252,149.23h-6.37l-43.51,16.54s2,14.78,4.41,30.18l7.2,9.92a9.91,9.91,0,0,0,8,4.09h58.13a9.91,9.91,0,0,0,8.31-4.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.84,210.46H221.71a10.47,10.47,0,0,1-8.43-4.3l-7.2-9.91A.85.85,0,0,1,206,196c-2.42-15.23-4.39-30.05-4.41-30.2a.5.5,0,0,1,.32-.53l43.51-16.54.18,0H252a.47.47,0,0,1,.17,0l46.24,16.54a.5.5,0,0,1,.33.53c0,.16-2.08,15.69-4.59,31.31a.44.44,0,0,1-.07.19l-5.47,8.4A10.38,10.38,0,0,1,279.84,210.46ZM207,195.76l7.13,9.81a9.44,9.44,0,0,0,7.62,3.89h58.13a9.4,9.4,0,0,0,7.9-4.28l5.4-8.31c2.27-14.17,4.18-28.24,4.52-30.77l-45.78-16.37h-6.2l-43.05,16.36C203,168.54,204.77,182,207,195.76Zm86.66,1.3h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.6,
    cy: 193.95,
    r: 11.16,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6,205.61A11.66,11.66,0,1,1,261.26,194,11.67,11.67,0,0,1,249.6,205.61Zm0-22.32A10.66,10.66,0,1,0,260.26,194,10.67,10.67,0,0,0,249.6,183.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.84,194a5.24,5.24,0,1,0-5.24,5.24A5.25,5.25,0,0,0,254.84,194Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6,199.69a5.74,5.74,0,1,1,5.74-5.74A5.75,5.75,0,0,1,249.6,199.69Zm0-10.48a4.74,4.74,0,1,0,4.74,4.74A4.75,4.75,0,0,0,249.6,189.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.08,165.77l14,19.85a11.65,11.65,0,0,0,12.43,4.57h0a11.66,11.66,0,0,0,8.68-12.77l-3-23.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.69,191.05a12.25,12.25,0,0,1-10-5.14l-14-19.85a.53.53,0,0,1-.07-.44.56.56,0,0,1,.3-.32L234,153a.5.5,0,0,1,.43,0,.48.48,0,0,1,.24.36l3,23.95a12.14,12.14,0,0,1-12,13.7ZM202.86,166l13.66,19.33a11.18,11.18,0,0,0,20.22-7.85l-3-23.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14,165.77l-14,19.85a11.67,11.67,0,0,1-12.44,4.57h0A11.66,11.66,0,0,1,263,177.42l2.41-23.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.54,191.05a12.13,12.13,0,0,1-12-13.7l2.41-23.48a.48.48,0,0,1,.23-.37.5.5,0,0,1,.43-.05l32.74,11.85a.5.5,0,0,1,.24.76l-14,19.85A12.25,12.25,0,0,1,274.54,191.05Zm-8.71-36.44-2.34,22.86a11.17,11.17,0,0,0,20.21,7.86L297.36,166Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.16,214.4a1.58,1.58,0,1,0-1.57,1.57A1.57,1.57,0,0,0,273.16,214.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,216.47a2.07,2.07,0,1,1,2.07-2.07A2.08,2.08,0,0,1,271.59,216.47Zm0-3.14a1.07,1.07,0,1,0,1.07,1.07A1.08,1.08,0,0,0,271.59,213.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.46,214.4a1.58,1.58,0,1,0-1.57,1.57A1.57,1.57,0,0,0,280.46,214.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,216.47A2.07,2.07,0,1,1,281,214.4,2.08,2.08,0,0,1,278.89,216.47Zm0-3.14A1.07,1.07,0,1,0,280,214.4,1.08,1.08,0,0,0,278.89,213.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.77,214.4a1.58,1.58,0,1,0-1.58,1.57A1.57,1.57,0,0,0,287.77,214.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.19,216.47a2.07,2.07,0,1,1,2.08-2.07A2.07,2.07,0,0,1,286.19,216.47Zm0-3.14a1.07,1.07,0,1,0,1.08,1.07A1.07,1.07,0,0,0,286.19,213.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.93,
    cy: 259.64,
    r: 16.72,
    transform: "translate(-52.64 63.86) rotate(-13.19)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93,276.87a17.23,17.23,0,1,1,17.22-17.23A17.24,17.24,0,0,1,249.93,276.87Zm0-33.45a16.23,16.23,0,1,0,16.22,16.22A16.24,16.24,0,0,0,249.93,243.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.63,243a16.1,16.1,0,0,0-3.4,0v17.21h3.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.63,260.72h-3.4a.5.5,0,0,1-.5-.5V243a.49.49,0,0,1,.45-.5,17.06,17.06,0,0,1,3.5,0,.49.49,0,0,1,.45.5v17.21A.5.5,0,0,1,251.63,260.72Zm-2.9-1h2.4V243.46a19.22,19.22,0,0,0-2.4,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.15,196.92l-11.49,35a8.14,8.14,0,0,0,5.23,9.73h0a8.15,8.15,0,0,0,10.28-4.8l15.32-34.67-3-20.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.58,242.62a8.93,8.93,0,0,1-2.85-.48,8.7,8.7,0,0,1-5.56-10.33l11.5-35.05a.57.57,0,0,1,.13-.21L204.13,181a.5.5,0,0,1,.51-.11.47.47,0,0,1,.33.4l3,20.85a.5.5,0,0,1,0,.27l-15.32,34.67A8.6,8.6,0,0,1,184.58,242.62Zm4-45.43-11.46,34.9a7.65,7.65,0,0,0,14.57,4.59L207,202.12l-2.86-19.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.08,165.77s-9.91,1.76-14.18,11.3,0,23.36,0,23.36h3.26l13.32-19.09Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.16,200.93H187.9a.5.5,0,0,1-.48-.35c-.18-.57-4.28-14.11,0-23.71s14.45-11.58,14.55-11.59a.47.47,0,0,1,.38.08.5.5,0,0,1,.2.33l2.4,15.58a.52.52,0,0,1-.08.36l-13.32,19.09A.49.49,0,0,1,191.16,200.93Zm-2.89-1h2.63l13-18.71-2.28-14.85c-2,.51-9.75,2.93-13.32,10.9C184.58,185.7,187.66,197.73,188.27,199.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.09,165.52s-6,43.71-4.77,49.23,3.52,22.86,6.28,25.62,10.3,4.28,13.56-.75,3.27-24.87,2.77-29.89-8-44.27-8-44.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,243.42a11,11,0,0,1-7.35-2.69c-2-2-3.56-10.08-5.25-19.66-.45-2.57-.85-4.78-1.17-6.21-1.26-5.55,4.52-47.62,4.77-49.41a.49.49,0,0,1,.49-.43l9.84-.06a.53.53,0,0,1,.5.41c.3,1.6,7.5,39.32,8,44.31.45,4.43.61,24.91-2.84,30.21a7.73,7.73,0,0,1-5.92,3.48C185.31,243.4,185,243.42,184.6,243.42ZM176.53,166c-.62,4.55-5.88,43.54-4.72,48.63.32,1.45.72,3.68,1.17,6.26,1.21,6.84,3,17.19,5,19.12a10,10,0,0,0,7.61,2.35,6.81,6.81,0,0,0,5.18-3c3.11-4.77,3.22-24.26,2.69-29.57-.47-4.67-7.11-39.62-7.91-43.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.32,214.75c.82,3.6,2.06,12.21,3.59,18.54h9.23V201H171.86C171.24,207.61,170.93,213,171.32,214.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,233.79h-9.23a.49.49,0,0,1-.48-.38c-.93-3.82-1.76-8.54-2.43-12.34-.45-2.57-.85-4.78-1.17-6.21-.36-1.61-.19-6.17.53-14a.5.5,0,0,1,.5-.45h12.28a.5.5,0,0,1,.5.5v32.33A.5.5,0,0,1,184.14,233.79Zm-8.83-1h8.33V201.46H172.32c-.83,9.07-.74,12.18-.51,13.18h0c.32,1.45.72,3.68,1.17,6.26C173.63,224.55,174.43,229.07,175.31,232.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.96 166.89 176.48 163.39 185.55 163.39 186.19 167.53 175.96 166.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19,168h0l-10.23-.64a.52.52,0,0,1-.36-.19.5.5,0,0,1-.11-.39l.52-3.5a.51.51,0,0,1,.5-.42h9.07a.5.5,0,0,1,.49.42l.65,4.15a.48.48,0,0,1-.13.41A.47.47,0,0,1,186.19,168Zm-9.66-1.61,9.07.58-.48-3.11h-8.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.66,151l-4.8-7s-9.2,5.06-11.4,8.42-2.85,8.43-.39,12S183,163.13,183,163.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.07,166.25a3.87,3.87,0,0,1-3.41-1.54c-2.75-4.06-1.73-9.38.38-12.61,2.25-3.43,11.2-8.38,11.58-8.59a.5.5,0,0,1,.65.16l4.8,7a.5.5,0,0,1,0,.49l-5.7,12.18a.61.61,0,0,1-.2.22C183,163.71,178.55,166.25,175.07,166.25Zm8.64-21.64c-1.77,1-9,5.2-10.83,8s-2.89,7.82-.4,11.49c1.78,2.61,7.75,0,10.09-1.37L188.08,151Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.71,146.41s0-2.33,3.76-1.55,3,4.4,2.59,6.09-.26,6.74-1.68,8.55-3.11,4.54-6.87,4.54-4-5.06-2.85-7.26,5.44-8.42,5.44-8.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51,164.54a3.56,3.56,0,0,1-3.19-1.78,7,7,0,0,1-.1-6.21c1.07-2,4.63-7.26,5.35-8.3l-.35-1.74s0-.06,0-.1a2.18,2.18,0,0,1,.81-1.59,4.16,4.16,0,0,1,3.55-.45,4,4,0,0,1,2.7,1.69c1,1.64.53,3.91.28,5a19.78,19.78,0,0,0-.26,2.23c-.19,2.29-.44,5.14-1.52,6.52l-.41.53C190,162.11,188.16,164.54,184.51,164.54Zm2.71-18.16.37,1.88a.47.47,0,0,1-.08.38c0,.06-4.27,6.22-5.41,8.37a6,6,0,0,0,.08,5.24,2.57,2.57,0,0,0,2.33,1.29c3.16,0,4.7-2,6.06-3.81l.41-.54c.9-1.14,1.14-3.94,1.31-6a23.36,23.36,0,0,1,.28-2.36c.23-1,.68-3-.14-4.24a3,3,0,0,0-2.06-1.25,3.41,3.41,0,0,0-2.71.23A1.18,1.18,0,0,0,187.22,146.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.71,146.41a75.76,75.76,0,0,0-5.18,6c-.65,1.17.13,1.82,2.2,1.82s7-1.82,7.91-4.15S189.3,144.08,186.71,146.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.73,154.69c-1.47,0-2.37-.31-2.75-.95a1.57,1.57,0,0,1,.11-1.61,69.31,69.31,0,0,1,5.26-6.06l0,0a3.1,3.1,0,0,1,4-.25,4,4,0,0,1,1.68,4.43C191.1,152.8,186,154.69,183.73,154.69Zm3.33-7.92a68.47,68.47,0,0,0-5.09,5.85c-.09.16-.23.45-.13.62s.7.45,1.89.45c2,0,6.64-1.77,7.44-3.83a3,3,0,0,0-1.32-3.25A2.12,2.12,0,0,0,187.06,146.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,145.25s-1.68-5.19-3.11-6.48-5.18.39-5.18,1.17.65,7,1.42,7.64A4.52,4.52,0,0,0,187.36,145.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16,148.87a5.24,5.24,0,0,1-3-.91c-1.1-.92-1.6-8-1.6-8,0-.72,1-1.29,1.67-1.56,1.34-.6,3.28-.95,4.35,0,1.48,1.35,3.07,6.15,3.25,6.69a.52.52,0,0,1,0,.35,5.17,5.17,0,0,1-3.52,3.3A5,5,0,0,1,183.16,148.87Zm-.4-10.08a4.28,4.28,0,0,0-.83.09,4.43,4.43,0,0,0-2.37,1.13c0,1,.7,6.59,1.26,7.19a4.32,4.32,0,0,0,3.25.56,4.12,4.12,0,0,0,2.76-2.54c-.52-1.53-1.87-5.13-2.92-6.08A1.66,1.66,0,0,0,182.76,138.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.51,139.29a5.54,5.54,0,0,1-3.11,1.94c-1.81.26-2.46-.13-3.37-1.68s-1-3.37,1.56-3.76A4.66,4.66,0,0,1,184.51,139.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5,141.8c-1.32,0-2.05-.55-2.9-2a3.35,3.35,0,0,1-.45-3.08,2.86,2.86,0,0,1,2.36-1.43,5.17,5.17,0,0,1,5.49,3.92.48.48,0,0,1-.09.38,6,6,0,0,1-3.44,2.14A7,7,0,0,1,180.5,141.8Zm-.34-5.55-.5,0c-.85.13-1.39.42-1.6.87a2.42,2.42,0,0,0,.4,2.14c.83,1.43,1.31,1.67,2.87,1.45a4.82,4.82,0,0,0,2.64-1.59A4.3,4.3,0,0,0,180.16,136.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.67,138.36a2.35,2.35,0,0,0-1.06-2.94,4.58,4.58,0,0,0-2.19-.67c-1.81,0-5.31,2.59-5.57,4.67s3.76,1.29,6.22.52C180.65,139.44,181.32,139.15,181.67,138.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.8,141.25a3.09,3.09,0,0,1-2-.51,1.48,1.48,0,0,1-.5-1.39c.29-2.31,4-5.1,6.07-5.1a5.13,5.13,0,0,1,2.44.73,2.85,2.85,0,0,1,1.27,3.58h0c-.45,1-1.36,1.36-2.91,1.85A16.38,16.38,0,0,1,174.8,141.25Zm3.62-6c-1.65,0-4.85,2.45-5.08,4.23a.5.5,0,0,0,.15.49c.62.51,2.85.3,5.43-.51,1.55-.49,2-.72,2.29-1.3h0a1.85,1.85,0,0,0-.84-2.31A4.18,4.18,0,0,0,178.42,135.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.75,147a3.49,3.49,0,0,0-5.63-2.43,3,3,0,0,0-.62.7c-1.69,2.46,1.16,7.12,1.68,8.42s1.3,6.22,3.63,6.61,1.68-6.09,1.29-8.81C179.88,149.93,179.91,148.43,179.75,147Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,160.79a1.23,1.23,0,0,1-.27,0c-2.16-.36-3.06-3.6-3.66-5.74-.14-.5-.25-.93-.35-1.17s-.23-.51-.41-.87c-1-2-2.8-5.73-1.23-8a4.24,4.24,0,0,1,.72-.8,3.7,3.7,0,0,1,3.83-.63,4.13,4.13,0,0,1,2.61,3.38h0c.08.66.11,1.33.15,2s.09,1.64.21,2.47c.39,2.76.84,7.59-.57,9A1.44,1.44,0,0,1,179,160.79Zm-2.81-16.53a2.68,2.68,0,0,0-1.74.66,3.15,3.15,0,0,0-.54.61c-1.24,1.81.48,5.33,1.3,7,.19.39.35.71.44.93s.23.73.39,1.28c.49,1.78,1.32,4.77,2.85,5a.46.46,0,0,0,.44-.13c.77-.75.88-3.94.28-8.12-.13-.87-.17-1.73-.22-2.56,0-.66-.07-1.31-.14-1.95h0a3.15,3.15,0,0,0-2-2.56A2.91,2.91,0,0,0,176.19,144.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,153.67a5,5,0,0,1,4.92-1.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,154.17a.5.5,0,0,1-.38-.82,5.52,5.52,0,0,1,5.43-1.72.5.5,0,1,1-.25,1,4.58,4.58,0,0,0-4.42,1.39A.48.48,0,0,1,175.18,154.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.11,153.22a2.89,2.89,0,0,0-4.93-1.18,2.73,2.73,0,0,0-.41.66c-1,2.25,2,5.64,2.57,6.63s1.94,4.88,3.9,4.87.5-5.21-.2-7.37C168.64,155.61,168.45,154.38,168.11,153.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.22,164.7c-1.85,0-3.05-2.54-3.85-4.22-.18-.38-.33-.69-.45-.89s-.26-.38-.45-.64c-1.1-1.51-3.13-4.32-2.15-6.46a3.61,3.61,0,0,1,.47-.77,3.16,3.16,0,0,1,3.12-1.08,3.49,3.49,0,0,1,2.68,2.44c.16.53.28,1.07.41,1.62s.3,1.32.52,2c.87,2.69,1.72,6.18.8,7.47a1.33,1.33,0,0,1-1.08.55Zm-4-13.13a2.09,2.09,0,0,0-1.66.79,2.2,2.2,0,0,0-.34.55c-.74,1.61,1.14,4.2,2.05,5.45.21.29.38.53.49.7s.3.57.5,1c.61,1.27,1.73,3.64,3,3.64a.23.23,0,0,0,.27-.14c.51-.69.14-3.27-.93-6.57-.23-.7-.39-1.4-.55-2.07-.12-.52-.24-1-.39-1.56h0a2.49,2.49,0,0,0-1.92-1.74A2.61,2.61,0,0,0,165.23,151.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.34,159.33a4.17,4.17,0,0,1,3.79-2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.34,159.83a.47.47,0,0,1-.25-.07.49.49,0,0,1-.18-.68,4.64,4.64,0,0,1,4.26-2.22.5.5,0,0,1,.46.54.5.5,0,0,1-.54.46,3.73,3.73,0,0,0-3.32,1.72A.5.5,0,0,1,165.34,159.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.76,149.22a3.18,3.18,0,0,0-5.42-1.3,3.13,3.13,0,0,0-.46.73c-1.12,2.47,2.16,6.21,2.83,7.29s2.14,5.37,4.29,5.36.56-5.73-.22-8.11C173.35,151.85,173.14,150.5,172.76,149.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,161.8c-2,0-3.33-2.77-4.2-4.61-.2-.42-.37-.77-.5-1s-.29-.41-.5-.71c-1.19-1.65-3.42-4.72-2.36-7.05a3.59,3.59,0,0,1,.52-.84,3.4,3.4,0,0,1,3.38-1.17,3.8,3.8,0,0,1,2.91,2.65h0c.17.58.31,1.17.45,1.78s.33,1.45.57,2.18c.79,2.42,2,6.7.89,8.17a1.4,1.4,0,0,1-1.15.59Zm-4.4-14.45a2.38,2.38,0,0,0-1.87.89,2.72,2.72,0,0,0-.38.61c-.82,1.8,1.26,4.67,2.26,6.05l.54.77c.14.24.33.63.55,1.09.67,1.41,1.92,4,3.3,4a.37.37,0,0,0,.34-.17c.57-.78.16-3.64-1-7.28-.25-.77-.43-1.53-.6-2.27-.13-.58-.26-1.16-.43-1.72h0a2.78,2.78,0,0,0-2.15-2A2.55,2.55,0,0,0,169.59,147.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.71,155.94a4.6,4.6,0,0,1,4.17-2.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.71,156.44a.59.59,0,0,1-.25-.07.49.49,0,0,1-.18-.68,5.07,5.07,0,0,1,4.65-2.42.5.5,0,0,1-.09,1,4.05,4.05,0,0,0-3.7,1.92A.5.5,0,0,1,169.71,156.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23,196.92l11.49,35a8.14,8.14,0,0,1-5.24,9.73h0a8.14,8.14,0,0,1-10.27-4.8l-15.32-34.67,3-20.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.8,242.62a8.63,8.63,0,0,1-8.06-5.58l-15.31-34.65a.5.5,0,0,1,0-.27l3-20.85a.5.5,0,0,1,.34-.4.49.49,0,0,1,.5.11l16.33,15.57a.46.46,0,0,1,.13.21l11.5,35a8.72,8.72,0,0,1-5.55,10.36A8.93,8.93,0,0,1,315.8,242.62Zm-22.4-40.5,15.27,34.54a7.62,7.62,0,0,0,9.65,4.53,7.69,7.69,0,0,0,4.92-9.13l-11.45-34.87-15.53-14.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.3,165.77s9.91,1.76,14.18,11.3,0,23.36,0,23.36h-3.27L295.9,181.34Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,200.93h-3.27a.52.52,0,0,1-.41-.21l-13.31-19.09a.52.52,0,0,1-.08-.36l2.39-15.58a.52.52,0,0,1,.21-.33.45.45,0,0,1,.37-.08c.11,0,10.23,1.91,14.56,11.59s.19,23.14,0,23.71A.5.5,0,0,1,312.48,200.93Zm-3-1h2.63c.62-2.2,3.69-14.23-.08-22.66-3.57-8-11.28-10.39-13.31-10.9l-2.29,14.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,227s-15.05-4.49-20.59-5.28-9.76,1.32-10.29,6.34,3.43,13.46,11.35,14.25,20.85-4.75,20.85-4.75a7.82,7.82,0,0,0,3.43-6.34C339.72,227,335,227,335,227Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.1,242.92c-.59,0-1.16,0-1.71-.08a12.38,12.38,0,0,1-8.4-4.67,14.7,14.7,0,0,1-3.4-10.14,7.36,7.36,0,0,1,2.7-5.18c2-1.52,4.79-2.08,8.16-1.59,5.38.76,19.35,4.9,20.59,5.27,1.84,0,5.18,1,5.18,4.72a8.25,8.25,0,0,1-3.67,6.76C336,238.26,325,242.92,317.1,242.92Zm-4.88-20.83a8.57,8.57,0,0,0-5.31,1.55,6.32,6.32,0,0,0-2.33,4.5,13.9,13.9,0,0,0,3.19,9.4,11.35,11.35,0,0,0,7.72,4.3c7.69.78,20.47-4.66,20.6-4.71a7.27,7.27,0,0,0,3.13-5.88c0-3.66-4.08-3.72-4.25-3.72l-.14,0c-.15,0-15.08-4.49-20.52-5.26A13.85,13.85,0,0,0,312.22,222.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.8,236.16C316.34,238.61,311,237,311,237l1.57,4.69a10.8,10.8,0,0,0,2.85.67c4.14.41,9.65-.91,14-2.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06,242.91c-.58,0-1.14,0-1.67-.07a12.2,12.2,0,0,1-3-.7.49.49,0,0,1-.3-.31l-1.56-4.7a.49.49,0,0,1,.62-.63c.05,0,5.37,1.56,16.53-.83a.49.49,0,0,1,.57.3l1.6,3.92a.5.5,0,0,1,0,.4.5.5,0,0,1-.3.27A45.55,45.55,0,0,1,317.06,242.91ZM313,241.29a11.25,11.25,0,0,0,2.51.55c4,.4,9.3-.87,13.25-2.08l-1.24-3c-8.69,1.81-13.78,1.29-15.72.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,234.77s2.46,4.75,2.11,5.81-2.64,2.64-4,1.93-4.75-6.68-4.75-8.27S361.54,234.77,361.54,234.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.39,243.19a2.27,2.27,0,0,1-1-.23c-1.64-.82-5-7-5-8.72a.92.92,0,0,1,.4-.77c1.21-.89,5.62.41,6.94.83a.44.44,0,0,1,.29.24c.6,1.16,2.53,5,2.15,6.2a4.36,4.36,0,0,1-2.38,2.15A3.53,3.53,0,0,1,360.39,243.19ZM356,234.14a1.12,1.12,0,0,0-.68.14c0,1.43,3.33,7.2,4.5,7.79a1.92,1.92,0,0,0,1.54-.1,3.51,3.51,0,0,0,1.81-1.55c.16-.51-.89-3.07-2-5.23A21.23,21.23,0,0,0,356,234.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.6,242.51s-3,2.82-2.46,3.88,3.34.52,4.75-.88,3-3.52,1.76-4.93C362.58,239.36,359.6,242.51,359.6,242.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.46,247.44a3,3,0,0,1-.53,0,1.55,1.55,0,0,1-1.24-.79c-.62-1.25,1.57-3.52,2.56-4.45.28-.29,2.32-2.36,3.78-2.36a1.32,1.32,0,0,1,1,.45c1.15,1.32.51,3.31-1.79,5.61A5.76,5.76,0,0,1,358.46,247.44ZM363,240.8c-.79,0-2.28,1.26-3,2.06l0,0c-1.4,1.31-2.55,2.91-2.36,3.28.08.17.35.23.5.26a4.66,4.66,0,0,0,3.45-1.27c.87-.87,2.79-3,1.73-4.24a.28.28,0,0,0-.26-.11Zm-3.4,1.71h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,234.77s2.47,4.75,2.12,5.81-2.64,2.64-4.05,1.93-4.75-6.68-4.75-8.27S357,234.77,357,234.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.82,243.19a2.31,2.31,0,0,1-1-.23c-1.63-.82-5-7-5-8.72a.93.93,0,0,1,.39-.77c1.21-.89,5.62.41,6.94.83a.45.45,0,0,1,.3.24c.6,1.16,2.53,5,2.14,6.2a4.34,4.34,0,0,1-2.37,2.15A3.57,3.57,0,0,1,355.82,243.19Zm-4.39-9.05a1.08,1.08,0,0,0-.67.14c0,1.43,3.32,7.2,4.49,7.79a1.92,1.92,0,0,0,1.54-.1,3.47,3.47,0,0,0,1.81-1.55c.16-.51-.88-3.07-2-5.23A21.2,21.2,0,0,0,351.43,234.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,242.51s-3,2.82-2.47,3.88,3.35.52,4.76-.88,3-3.52,1.76-4.93C358,239.36,355,242.51,355,242.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.88,247.44a3.08,3.08,0,0,1-.53,0,1.53,1.53,0,0,1-1.23-.79c-.63-1.25,1.57-3.52,2.55-4.45.28-.29,2.34-2.36,3.79-2.36a1.3,1.3,0,0,1,1,.45c1.15,1.32.52,3.31-1.78,5.61A5.81,5.81,0,0,1,353.88,247.44Zm4.54-6.64c-.79,0-2.27,1.26-3,2.06l0,0c-1.4,1.32-2.54,2.91-2.36,3.28.08.17.35.23.5.26a4.65,4.65,0,0,0,3.45-1.27c.88-.87,2.79-3,1.74-4.24a.29.29,0,0,0-.26-.11ZM355,242.51h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76,234.64s.16,5.35-.62,6.14-3.52,1.23-4.49,0-1.37-8.09-.68-9.51S354.76,234.64,354.76,234.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,242.05h-.28a2.8,2.8,0,0,1-2.16-1c-1.12-1.44-1.48-8.51-.74-10a.94.94,0,0,1,.69-.53c1.48-.28,4.88,2.81,5.89,3.76a.48.48,0,0,1,.16.35c0,1.31.09,5.63-.76,6.51A4.21,4.21,0,0,1,351.7,242.05Zm-2.23-10.57-.08,0c-.61,1.29-.14,7.93.66,9a1.87,1.87,0,0,0,1.43.58,3.51,3.51,0,0,0,2.3-.6c.37-.39.54-3.16.49-5.58C352.25,233,350.11,231.48,349.47,231.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.65,240.77s-3.91,1.24-3.9,2.42,2.79,1.92,4.67,1.27,4.22-1.87,3.72-3.68C353.71,239.22,349.65,240.77,349.65,240.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.84,245.2a5.13,5.13,0,0,1-2.82-.75,1.59,1.59,0,0,1-.77-1.26c0-1.39,2.95-2.48,4.24-2.89.38-.15,3.12-1.15,4.43-.49a1.3,1.3,0,0,1,.7.84c.47,1.69-1,3.21-4,4.28A5.47,5.47,0,0,1,348.84,245.2Zm4-4.61a9.72,9.72,0,0,0-3,.65h0c-1.83.57-3.55,1.51-3.55,1.93,0,.18.22.36.34.45a4.66,4.66,0,0,0,3.66.35c1.17-.4,3.83-1.52,3.41-3.06a.34.34,0,0,0-.19-.22A1.61,1.61,0,0,0,352.79,240.59Zm-3.14.18h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,226.67a5.37,5.37,0,0,0-2.78,1c-1.58,1.14-4,3.25-4.16,5.71-.27,3.7,3.43,4.76,6.86,4.76s10-4.76,10-4.76,2.62-5.37-.28-6.16A34.55,34.55,0,0,0,339.8,226.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.72,238.62c-2,0-4.76-.35-6.29-2a4.14,4.14,0,0,1-1.07-3.29c.18-2.57,2.48-4.73,4.37-6.08a5.72,5.72,0,0,1,3-1.08h0c2.43-.13,6.93-.24,9.83.55a2.17,2.17,0,0,1,1.47,1.23c.88,1.94-.69,5.26-.87,5.63a.49.49,0,0,1-.16.19C349.77,234,343.27,238.62,339.72,238.62Zm3.39-11.54c-1.25,0-2.4,0-3.28.09h0a4.77,4.77,0,0,0-2.51.89c-1.41,1-3.8,3-4,5.34a3.15,3.15,0,0,0,.8,2.54c1.36,1.46,4.07,1.68,5.56,1.68,3,0,8.79-4,9.63-4.59.46-1,1.37-3.44.81-4.67a1.18,1.18,0,0,0-.82-.68A26,26,0,0,0,343.11,227.08Zm-3.31-.41h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.94,235.74a42,42,0,0,0,10.56.53c5-.53,5.28-7.13,2.38-7.92s-6.07-1.58-9-.79S342.36,233.63,343.94,235.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.45,236.92a44.29,44.29,0,0,1-7.6-.69.51.51,0,0,1-.31-.19c-.7-.93-.76-2.37-.19-4,.68-2,2.35-4.35,4.42-4.91,2.93-.8,6-.09,9.24.79,1.46.4,2.37,2.07,2.21,4.07a5.14,5.14,0,0,1-4.67,4.82A29.4,29.4,0,0,1,351.45,236.92Zm-7.21-1.63a42,42,0,0,0,10.21.48,4.14,4.14,0,0,0,3.78-3.91c.12-1.51-.49-2.76-1.49-3-3.06-.83-6-1.52-8.71-.79-1.45.4-3,2.19-3.73,4.27A3.78,3.78,0,0,0,344.24,235.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.78,236.88a10.14,10.14,0,0,0-4.23-2.81c-2.64-.88-3.69,1.23-2.64,4.05s4.93,7.39,5.28,8.79,3.52,1.41,3.87-1.76S340.78,236.88,340.78,236.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.6,248.31a1.83,1.83,0,0,1-1.89-1.28,18.76,18.76,0,0,0-2-3.27,30.54,30.54,0,0,1-3.25-5.47c-.67-1.78-.57-3.37.28-4.25a2.67,2.67,0,0,1,3-.45,10.44,10.44,0,0,1,4.45,3l.06.08c.11.22,2.7,5.28,2.34,8.56a3.14,3.14,0,0,1-2.78,3.1Zm-5.17-13.95a1.32,1.32,0,0,0-1,.37c-.56.59-.59,1.82-.07,3.21a30.06,30.06,0,0,0,3.15,5.26,16.19,16.19,0,0,1,2.15,3.59c.08.34.52.55,1,.52.79-.05,1.68-.66,1.86-2.21.31-2.82-1.95-7.41-2.21-7.94a9.88,9.88,0,0,0-4-2.62A3.34,3.34,0,0,0,335.43,234.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.38,242.34s3-3.7,5.8-1.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.38,242.84a.52.52,0,0,1-.32-.11A.51.51,0,0,1,336,242a6.11,6.11,0,0,1,3.75-2.18,3.58,3.58,0,0,1,2.78,1.08.48.48,0,0,1,0,.7.5.5,0,0,1-.71,0,2.61,2.61,0,0,0-2-.81,5.3,5.3,0,0,0-3.05,1.81A.49.49,0,0,1,336.38,242.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,228.79s-2.64,1.58-2.64,4.05,1.23,3,2.64,3.34,4.57,2.11,6,1.41,3.87-3.17,1.23-5.81S358,228.79,358,228.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,238.25a11.6,11.6,0,0,1-3.78-1.05c-.58-.23-1.13-.44-1.5-.54-1.46-.36-3-1-3-3.82s2.76-4.41,2.88-4.48a.53.53,0,0,1,.3-.07c.19,0,4.79.4,7.53,3.14a3.73,3.73,0,0,1,1.27,3.3,5,5,0,0,1-2.63,3.3A2.27,2.27,0,0,1,363.18,238.25Zm-5-8.95c-.51.35-2.27,1.69-2.27,3.54,0,2.12.94,2.52,2.26,2.85a15.24,15.24,0,0,1,1.63.58c1.35.54,3.2,1.27,4,.87a4,4,0,0,0,2.09-2.57,2.8,2.8,0,0,0-1-2.44C362.68,229.93,359,229.4,358.15,229.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.47,233.89s-3.35-.17-3.52,1.94.7,2.46,1.58,3.16,3.34,2.64,4.4,1.41S368.4,234.77,366.47,233.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,241.3c-1.4,0-3.12-1.37-3.8-1.91-.1-.09-.21-.16-.31-.24a3.14,3.14,0,0,1-1.46-3.36c.21-2.57,3.89-2.4,4-2.4a.53.53,0,0,1,.18.05c1.42.64,2.56,2.76,2.95,4.51a3.29,3.29,0,0,1-.31,2.78A1.63,1.63,0,0,1,368,241.3Zm-1.74-6.91c-.6,0-2.72.1-2.84,1.48a2.21,2.21,0,0,0,1.07,2.48l.33.25c2.57,2.05,3.42,1.81,3.71,1.48a2.41,2.41,0,0,0,.09-1.91,6,6,0,0,0-2.3-3.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.53,312.19s-7.75,17.95-7.75,29.92,8.1,40.12,8.1,40.12V403H218l.36-24.63s8.09-23.58,8.79-42.94-4.22-24.63-4.22-24.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,403.49H203.88a.5.5,0,0,1-.5-.5V382.3c-.54-1.89-8.1-28.47-8.1-40.19,0-11.93,7.71-29.93,7.79-30.11a.48.48,0,0,1,.42-.3l19.36-1.41a.51.51,0,0,1,.4.16c.2.22,5.06,5.65,4.35,25-.67,18.66-8.29,41.5-8.79,43L218.45,403A.49.49,0,0,1,218,403.49Zm-13.57-1h13.08l.35-24.14a.88.88,0,0,1,0-.16c.08-.23,8.08-23.73,8.77-42.79.62-17-3.16-23-3.95-24.1l-18.78,1.37c-1,2.32-7.59,18.52-7.59,29.44,0,11.76,8,39.7,8.08,40a.59.59,0,0,1,0,.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.86,311.73V403H218l.36-24.63s8.09-23.58,8.79-42.94-4.22-24.63-4.22-24.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,403.49h-8.09a.5.5,0,0,1-.5-.5V311.73a.5.5,0,0,1,.46-.5l13-.94a.51.51,0,0,1,.4.16c.2.22,5.06,5.65,4.35,25-.67,18.66-8.29,41.5-8.79,43L218.45,403A.49.49,0,0,1,218,403.49Zm-7.59-1h7.1l.35-24.14a.88.88,0,0,1,0-.16c.08-.23,8.08-23.73,8.77-42.79.62-17-3.16-23-3.95-24.1l-12.29.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.22,311.84s8.79-5.63,10.55-15.13-6.68-23.93-15.83-29.91-24.29,7.39-31,20.76,6,25.34,18.65,28.51S229.22,311.84,229.22,311.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.56,317.35a25.15,25.15,0,0,1-6.06-.8c-8.64-2.16-16.23-7.9-19.32-14.63a16.35,16.35,0,0,1,.34-14.58c4.55-9.1,13.86-19.59,22.84-22a10.53,10.53,0,0,1,8.85,1.06c8.95,5.85,17.91,20.41,16.06,30.42-1.71,9.23-9.75,14.78-10.7,15.41C229,312.91,225.41,317.35,217.56,317.35Zm1.3-51.52a12.22,12.22,0,0,0-3.23.46c-7.68,2.07-17,11.11-22.21,21.49a15.37,15.37,0,0,0-.33,13.73c3,6.46,10.29,12,18.65,14.07,12.15,3,16.87-3.73,17.06-4a.67.67,0,0,1,.15-.14c.08-.05,8.63-5.63,10.33-14.8,1.79-9.64-6.93-23.72-15.62-29.4A8.54,8.54,0,0,0,218.86,265.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.22,301.42a.51.51,0,0,1-.5-.5,93,93,0,0,0-.84-12.25c-.65-3.88-1-7.31-1.21-8.71l-7.46,3.14a.49.49,0,0,1-.44,0,.52.52,0,0,1-.25-.38l-1.27-12.76a.49.49,0,0,1,.45-.54.48.48,0,0,1,.54.44l1.21,12.08,7.45-3.14a.48.48,0,0,1,.45,0,.51.51,0,0,1,.25.38s.43,4.29,1.27,9.32a94.4,94.4,0,0,1,.85,12.41A.5.5,0,0,1,219.22,301.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.67,
    cy: 310.96,
    r: 14.25,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,325.72A14.76,14.76,0,1,1,230.42,311,14.78,14.78,0,0,1,215.67,325.72Zm0-28.51A13.76,13.76,0,1,0,229.42,311,13.77,13.77,0,0,0,215.67,297.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.29,301.21l2,11h15.82l2.63-11.32a14.23,14.23,0,0,0-20.42.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08,312.67H207.26a.49.49,0,0,1-.49-.41l-2-11a.48.48,0,0,1,.13-.43,14.72,14.72,0,0,1,21.13-.37.5.5,0,0,1,.14.46l-2.64,11.33A.49.49,0,0,1,223.08,312.67Zm-15.4-1h15L225.16,301a13.73,13.73,0,0,0-19.33.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.88,403s-4.58,13.37-6.69,16.19-10.2,12-15.48,15.48-.71,5.28.7,5.28h34.84s2.82.71,2.46-8.44S218,403,218,403Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.39,440.45h-35c-.86,0-3.13-.63-3.6-2.18-.38-1.25.5-2.6,2.62-4,5.06-3.38,13.06-12.3,15.36-15.37,2-2.72,6.57-15.92,6.61-16.05a.51.51,0,0,1,.48-.34H218a.49.49,0,0,1,.5.46c0,.2,1.42,19.47,1.76,28.53.18,4.6-.4,7.48-1.72,8.55A1.77,1.77,0,0,1,217.39,440.45Zm0-1a.75.75,0,0,0,.53-.24c.58-.52,1.53-2.21,1.31-7.7-.31-8.26-1.5-25-1.72-28H204.23c-.74,2.15-4.67,13.36-6.64,16-2.33,3.11-10.45,12.16-15.61,15.6-1.66,1.11-2.44,2.13-2.21,2.89s1.89,1.47,2.64,1.47h34.84l.12,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,419.38c-2.31,3-10.16,11.84-15.33,15.28a5.62,5.62,0,0,0-2.37,2.47h29.82a24.37,24.37,0,0,0-3.87-14.08A7.6,7.6,0,0,0,197,419.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.16,437.63H179.34a.49.49,0,0,1-.4-.21.51.51,0,0,1-.07-.46,6.11,6.11,0,0,1,2.56-2.71c5.14-3.43,13-12.25,15.21-15.18a.51.51,0,0,1,.32-.19,8.12,8.12,0,0,1,8.75,3.91,24.6,24.6,0,0,1,3.94,14.39A.5.5,0,0,1,209.16,437.63Zm-29-1h28.49a24.57,24.57,0,0,0-3.82-13.32,7.07,7.07,0,0,0-7.55-3.47c-2.42,3.12-10.18,11.81-15.33,15.24A7.62,7.62,0,0,0,180.19,436.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.51,436.42a24.93,24.93,0,0,0,.2-4.92c-.09-2.48-.26-5.7-.46-9.09-2.82,3.39-6.93,9.15-6.93,14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.51,436.92h-7.19a.5.5,0,0,1-.5-.5c0-4.85,3.83-10.47,7-14.33a.5.5,0,0,1,.54-.15.48.48,0,0,1,.34.44c.23,3.8.39,6.86.47,9.1a26.64,26.64,0,0,1-.2,5A.51.51,0,0,1,219.51,436.92Zm-6.67-1h6.24a27.42,27.42,0,0,0,.13-4.4c-.07-2-.2-4.59-.39-7.79C216.38,426.82,213.09,431.72,212.84,435.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.42,409.68c-.26-3.93-.47-6.69-.47-6.69H203.88s-1.07,3.13-2.42,6.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.42,410.18h-17a.49.49,0,0,1-.41-.22.48.48,0,0,1-.06-.46c1.33-3.5,2.4-6.64,2.41-6.67a.51.51,0,0,1,.48-.34H218a.49.49,0,0,1,.5.46s.2,2.76.47,6.69a.5.5,0,0,1-.5.54Zm-16.24-1h15.71c-.19-2.72-.34-4.8-.4-5.69H204.23C203.94,404.32,203.15,406.6,202.18,409.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,312.19s7.74,17.95,7.74,29.92-8.09,40.12-8.09,40.12V403H282.56l-.35-24.63s-8.1-23.58-8.8-42.94,4.22-24.63,4.22-24.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.63,403.49H282.56a.5.5,0,0,1-.5-.49l-.35-24.56c-.51-1.5-8.12-24.34-8.8-43-.7-19.34,4.15-24.77,4.36-25a.47.47,0,0,1,.4-.16L297,311.7a.51.51,0,0,1,.43.3c.07.18,7.78,18.18,7.78,30.11,0,11.72-7.56,38.3-8.1,40.19V403A.5.5,0,0,1,296.63,403.49Zm-13.58-1h13.08V382.23a.59.59,0,0,1,0-.14c.09-.28,8.08-28.22,8.08-40,0-10.92-6.61-27.12-7.58-29.44l-18.79-1.37c-.78,1.07-4.57,7.12-3.95,24.1.69,19.06,8.69,42.56,8.77,42.79a.45.45,0,0,1,0,.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.65,311.73V403h-8.09l-.35-24.63s-8.1-23.58-8.8-42.94,4.22-24.63,4.22-24.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.65,403.49h-8.09a.5.5,0,0,1-.5-.49l-.35-24.56c-.51-1.5-8.12-24.34-8.8-43-.7-19.34,4.15-24.77,4.36-25a.47.47,0,0,1,.4-.16l13,.94a.5.5,0,0,1,.46.5V403A.5.5,0,0,1,290.65,403.49Zm-7.6-1h7.1V312.2l-12.29-.9c-.78,1.07-4.57,7.12-3.95,24.1.69,19.06,8.69,42.56,8.77,42.79a.45.45,0,0,1,0,.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,311.84s-8.8-5.63-10.56-15.13,6.69-23.93,15.84-29.91,24.28,7.39,31,20.76-6,25.34-18.65,28.51S271.3,311.84,271.3,311.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,317.35c-7.85,0-11.48-4.44-12-5.14-1-.63-9-6.18-10.7-15.41-1.86-10,7.11-24.57,16.05-30.42a10.57,10.57,0,0,1,8.85-1.06c9,2.43,18.29,12.92,22.84,22a16.35,16.35,0,0,1,.34,14.58c-3.09,6.73-10.67,12.47-19.32,14.63A25.09,25.09,0,0,1,283,317.35Zm-1.3-51.52a8.54,8.54,0,0,0-4.8,1.39c-8.69,5.68-17.4,19.76-15.62,29.4,1.7,9.17,10.25,14.75,10.34,14.8a.93.93,0,0,1,.14.14c.2.29,4.92,7.06,17.06,4,8.36-2.09,15.68-7.61,18.65-14.07a15.4,15.4,0,0,0-.32-13.73c-5.19-10.38-14.53-19.42-22.21-21.49A12.34,12.34,0,0,0,281.65,265.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,301.42a.5.5,0,0,1-.5-.5,93.3,93.3,0,0,1,.86-12.41c.83-5,1.26-9.28,1.27-9.32a.47.47,0,0,1,.24-.38.48.48,0,0,1,.45,0l7.45,3.14,1.21-12.08a.5.5,0,0,1,.55-.44.49.49,0,0,1,.44.54L292,282.69a.54.54,0,0,1-.24.38.51.51,0,0,1-.45,0L283.84,280c-.15,1.4-.56,4.83-1.21,8.71a93,93,0,0,0-.84,12.25A.5.5,0,0,1,281.29,301.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.85,
    cy: 310.96,
    r: 14.25,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.85,325.72A14.76,14.76,0,1,1,299.6,311,14.78,14.78,0,0,1,284.85,325.72Zm0-28.51A13.76,13.76,0,1,0,298.6,311,13.77,13.77,0,0,0,284.85,297.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.4,301.29l2,10.88h15.82l2.65-11.38a14.22,14.22,0,0,0-20.42.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.17,312.67H276.35a.49.49,0,0,1-.49-.41l-1.95-10.88A.5.5,0,0,1,274,301a14.72,14.72,0,0,1,21.14-.52.5.5,0,0,1,.13.47l-2.64,11.39A.51.51,0,0,1,292.17,312.67Zm-15.4-1h15L294.26,301a13.7,13.7,0,0,0-19.32.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.64,403s4.57,13.37,6.68,16.19,10.21,12,15.49,15.48.7,5.28-.71,5.28H283.26s-2.81.71-2.46-8.44S282.56,403,282.56,403Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.13,440.45A1.77,1.77,0,0,1,282,440c-1.32-1.07-1.9-3.95-1.72-8.55.35-9.06,1.75-28.33,1.76-28.53a.5.5,0,0,1,.5-.46h14.07a.51.51,0,0,1,.48.34c0,.13,4.57,13.33,6.61,16.05,2.3,3.07,10.31,12,15.36,15.37,2.12,1.41,3,2.76,2.62,4-.47,1.55-2.73,2.18-3.6,2.18h-35Zm-.11-37c-.21,3-1.4,19.77-1.72,28-.21,5.49.73,7.18,1.31,7.7a.72.72,0,0,0,.55.23H318.1c.76,0,2.37-.57,2.65-1.47s-.56-1.78-2.22-2.89c-5.15-3.44-13.28-12.49-15.61-15.6-2-2.63-5.9-13.84-6.64-16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.47,419.38c2.31,3,10.17,11.84,15.34,15.28a5.64,5.64,0,0,1,2.36,2.47H291.36a24.28,24.28,0,0,1,3.87-14.08A7.58,7.58,0,0,1,303.47,419.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.17,437.63H291.36a.51.51,0,0,1-.5-.45,24.6,24.6,0,0,1,3.94-14.39,8.13,8.13,0,0,1,8.75-3.91.51.51,0,0,1,.32.19c2.25,2.93,10.07,11.75,15.21,15.18a6.05,6.05,0,0,1,2.56,2.71.54.54,0,0,1-.06.46A.52.52,0,0,1,321.17,437.63Zm-29.34-1h28.49a7.42,7.42,0,0,0-1.79-1.55c-5.15-3.43-12.9-12.12-15.33-15.24a7.07,7.07,0,0,0-7.55,3.47A24.52,24.52,0,0,0,291.83,436.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,436.42a25.73,25.73,0,0,1-.2-4.92c.09-2.48.27-5.7.47-9.09,2.81,3.39,6.92,9.15,6.92,14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.19,436.92H281a.49.49,0,0,1-.49-.42,25.73,25.73,0,0,1-.21-5c.08-2.24.24-5.3.47-9.1a.5.5,0,0,1,.88-.29c3.21,3.86,7,9.48,7,14.33A.5.5,0,0,1,288.19,436.92Zm-6.76-1h6.24c-.24-4.2-3.53-9.1-6-12.19-.18,3.2-.32,5.81-.39,7.79A27.46,27.46,0,0,0,281.43,435.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.09,409.68c.27-3.93.47-6.69.47-6.69h14.08s1.07,3.13,2.41,6.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05,410.18h-17a.5.5,0,0,1-.5-.54c.27-3.93.47-6.69.47-6.69a.5.5,0,0,1,.5-.46h14.07a.51.51,0,0,1,.48.34s1.08,3.17,2.41,6.67a.51.51,0,0,1-.47.68Zm-16.43-1h15.71c-1-2.58-1.76-4.86-2.05-5.69H283C283,404.38,282.81,406.46,282.62,409.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,132.28v23.81a12.42,12.42,0,0,0,12.42,12.41h0a12.41,12.41,0,0,0,12.41-12.41V132.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.29,169a12.93,12.93,0,0,1-12.92-12.91V132.28a.51.51,0,0,1,.5-.5H261.7a.5.5,0,0,1,.5.5v23.81A12.92,12.92,0,0,1,249.29,169Zm-11.92-36.22v23.31a11.92,11.92,0,0,0,23.83,0V132.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.14,107.45s1.16-8.84-8.14-15.81-23.94-.47-26.5,9.06,0,29.3,0,29.3l11.39,15.11h10.69l12.09-15.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.58,145.61H243.89a.51.51,0,0,1-.4-.2L232.1,130.3a.51.51,0,0,1-.1-.24c-.1-.81-2.54-20,0-29.49,1.33-4.93,5.77-9.25,11.61-11.26S255,88,259.3,91.24c9.25,6.94,8.42,15.58,8.34,16.24l-.47,22.29a.51.51,0,0,1-.1.3L255,145.42A.51.51,0,0,1,254.58,145.61Zm-10.44-1h10.2l11.84-15,.46-22.15v-.06c0-.08,1-8.64-7.94-15.34-4-3-9.37-3.65-14.76-1.79s-9.74,6-11,10.58c-2.39,8.93-.22,27.24,0,29Zm22.53-14.85h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5,100.7a34,34,0,0,0-.92,5.82h35.6c0-2.45-.69-9.27-8.18-14.88C249.7,84.66,235.06,91.17,232.5,100.7Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.18,107h-35.6a.46.46,0,0,1-.36-.17.44.44,0,0,1-.13-.37,34.76,34.76,0,0,1,.92-5.91h0c1.33-4.93,5.77-9.25,11.61-11.26S255,88,259.3,91.24c7.6,5.69,8.39,12.58,8.38,15.28A.5.5,0,0,1,267.18,107Zm-35.05-1h34.55c-.1-2.83-1.18-8.88-8-14-4-3-9.37-3.65-14.76-1.79s-9.74,6-11,10.58h0A31.69,31.69,0,0,0,232.13,106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.53,106.83a.5.5,0,0,1-.5-.5v-4a.53.53,0,0,1,.15-.36l1.75-1.75v-6a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v6.16a.5.5,0,0,1-.14.35L240,102.51v3.82A.5.5,0,0,1,239.53,106.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,102.58a.5.5,0,0,1-.5-.5V97h-2.4a.5.5,0,0,1-.5-.5V91.35a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V96h2.4a.5.5,0,0,1,.5.5v5.59A.5.5,0,0,1,250.49,102.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,106.83a.5.5,0,0,1-.5-.5V99.4a.5.5,0,0,1,.5-.5h2.64V91.64a.5.5,0,1,1,1,0V99.4a.5.5,0,0,1-.5.5h-2.64v6.43A.5.5,0,0,1,255.86,106.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,95a.51.51,0,0,1-.5-.5V89.56a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v4.92A.5.5,0,0,1,253,95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.29,106.75h-3.73c-.77,10,.94,23.25.94,23.25l7.67,10.17v-9.24a5.74,5.74,0,0,0-1.1-3.38l-2.69-3.71a5.8,5.8,0,0,1-1.09-3.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.17,140.67a.51.51,0,0,1-.4-.2L232.1,130.3a.51.51,0,0,1-.1-.24c0-.13-1.71-13.38-.93-23.35a.49.49,0,0,1,.49-.46h3.73a.5.5,0,0,1,.5.5v13.71a5.18,5.18,0,0,0,1,3.08l2.69,3.72a6.23,6.23,0,0,1,1.19,3.67v9.24a.51.51,0,0,1-.34.48A.44.44,0,0,1,240.17,140.67ZM233,129.8l6.69,8.88v-7.75a5.25,5.25,0,0,0-1-3.08L236,124.13a6.19,6.19,0,0,1-1.19-3.67V107.25H232C231.39,116.52,232.81,128.43,233,129.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.12,108.51c-.05-.59-.09-1.18-.14-1.76h-3.72v13.71a5.74,5.74,0,0,1-1.1,3.38l-2.69,3.71a5.8,5.8,0,0,0-1.09,3.38v9.24l.49-.51,7.8-9.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.38,140.67a.58.58,0,0,1-.19,0,.5.5,0,0,1-.31-.47v-9.24a6.23,6.23,0,0,1,1.19-3.67l2.69-3.72a5.25,5.25,0,0,0,1-3.08V106.75a.5.5,0,0,1,.5-.5H267a.5.5,0,0,1,.5.46l.13,1.77a.07.07,0,0,1,0,0l-.45,21.24a.51.51,0,0,1-.1.3l-7.8,9.9-.53.55A.51.51,0,0,1,258.38,140.67Zm5.38-33.42v13.21a6.19,6.19,0,0,1-1.19,3.67l-2.69,3.72a5.18,5.18,0,0,0-1,3.08v7.92l7.3-9.26.44-21.06-.1-1.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.02 119.48 239.57 119.48 240.12 117.16 244.48 117.16 245.02 119.48",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,120h-5.44a.51.51,0,0,1-.4-.19.51.51,0,0,1-.09-.43l.54-2.31a.51.51,0,0,1,.49-.39h4.36a.49.49,0,0,1,.48.39l.55,2.31a.51.51,0,0,1-.1.43A.49.49,0,0,1,245,120Zm-4.81-1h4.18l-.31-1.32h-3.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.91 119.48 253.46 119.48 254.01 117.16 258.37 117.16 258.91 119.48",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.91,120h-5.45a.5.5,0,0,1-.48-.62l.54-2.31a.5.5,0,0,1,.49-.39h4.36a.49.49,0,0,1,.48.39l.55,2.31a.51.51,0,0,1-.1.43A.49.49,0,0,1,258.91,120Zm-4.82-1h4.19l-.31-1.32H254.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,134.14H245.7a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.67a.5.5,0,0,1,.5.5A.5.5,0,0,1,252.37,134.14Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Holograms--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.38,274.12A.52.52,0,0,1,333,274a.53.53,0,0,1-.08-.55l15-31.82a.51.51,0,0,1,.28-.26l76.45-26.48a.5.5,0,0,1,.54.14.51.51,0,0,1,.08.54l-15,31.82a.5.5,0,0,1-.29.26l-76.45,26.49A.45.45,0,0,1,333.38,274.12Zm15.35-31.92-14.4,30.55,75.13-26,14.4-30.56Zm61.1,4.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.22,260.43a.48.48,0,0,1-.37-.17.48.48,0,0,1-.08-.55l2.45-5.2a.51.51,0,0,1,.28-.26l13.37-4.62a.5.5,0,0,1,.54.13.53.53,0,0,1,.08.55l-2.45,5.2a.53.53,0,0,1-.29.26l-13.37,4.63A.45.45,0,0,1,366.22,260.43Zm2.81-5.3-1.85,3.94,12-4.18,1.86-3.93Zm10.55.17h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.07,263.28a.48.48,0,0,1-.37-.17.48.48,0,0,1-.08-.55l7.77-16.5a.53.53,0,0,1,.29-.26L419,221.46a.48.48,0,0,1,.53.14.47.47,0,0,1,.08.54l-7.77,16.51a.48.48,0,0,1-.29.25l-70.27,24.35A.41.41,0,0,1,341.07,263.28Zm8.14-16.6L342,261.92,411,238l7.18-15.24Zm62.13-8.25h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.14,249.48a.5.5,0,0,1-.17-1l69.55-24.1a.5.5,0,0,1,.32,1L348.3,249.45A.45.45,0,0,1,348.14,249.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.86,252.19a.5.5,0,0,1-.47-.33.5.5,0,0,1,.31-.64l69.54-24.09a.5.5,0,0,1,.33.94L347,252.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.58,254.9a.5.5,0,0,1-.16-1L415,229.84a.51.51,0,0,1,.64.31.5.5,0,0,1-.31.63l-69.54,24.1A.5.5,0,0,1,345.58,254.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31,257.62a.5.5,0,0,1-.17-1l69.54-24.09a.5.5,0,0,1,.33.95l-69.54,24.09A.45.45,0,0,1,344.31,257.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,260.33a.51.51,0,0,1-.48-.34.5.5,0,0,1,.31-.63l69.54-24.1a.5.5,0,0,1,.33,1L343.19,260.3A.45.45,0,0,1,343,260.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.67,240.2a.54.54,0,0,1-.22,0,.51.51,0,0,1-.24-.67L415,223a.49.49,0,0,1,.66-.24.5.5,0,0,1,.24.67l-7.77,16.5A.5.5,0,0,1,407.67,240.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.23,241.74a.54.54,0,0,1-.21-.05.49.49,0,0,1-.24-.66l7.77-16.5a.5.5,0,0,1,.67-.24.49.49,0,0,1,.24.66l-7.78,16.5A.49.49,0,0,1,403.23,241.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.8,243.28a.54.54,0,0,1-.21-.05.5.5,0,0,1-.24-.67l7.77-16.5a.5.5,0,0,1,.67-.24.51.51,0,0,1,.24.67L399.25,243A.49.49,0,0,1,398.8,243.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.37,244.81a.42.42,0,0,1-.22-.05.5.5,0,0,1-.24-.66l7.78-16.5a.5.5,0,1,1,.9.42l-7.77,16.5A.5.5,0,0,1,394.37,244.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.93,246.35a.54.54,0,0,1-.21,0,.5.5,0,0,1-.24-.67l7.77-16.5a.5.5,0,0,1,.67-.23.49.49,0,0,1,.24.66l-7.78,16.5A.49.49,0,0,1,389.93,246.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5,247.88a.52.52,0,0,1-.21,0,.5.5,0,0,1-.24-.67l7.77-16.5a.5.5,0,0,1,.67-.24.51.51,0,0,1,.24.67L386,247.6A.48.48,0,0,1,385.5,247.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.07,249.42a.59.59,0,0,1-.22,0,.5.5,0,0,1-.24-.66l7.78-16.5a.5.5,0,0,1,.9.42l-7.77,16.5A.51.51,0,0,1,381.07,249.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.63,251a.54.54,0,0,1-.21-.05.5.5,0,0,1-.24-.67l7.77-16.5a.5.5,0,1,1,.91.43l-7.78,16.5A.49.49,0,0,1,376.63,251Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,252.49a.41.41,0,0,1-.21-.05.49.49,0,0,1-.24-.66l7.77-16.5a.5.5,0,0,1,.91.42l-7.78,16.5A.49.49,0,0,1,372.2,252.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.77,254a.59.59,0,0,1-.22-.05.51.51,0,0,1-.24-.67l7.78-16.5a.5.5,0,0,1,.9.43l-7.77,16.5A.51.51,0,0,1,367.77,254Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.33,255.56a.52.52,0,0,1-.21,0,.5.5,0,0,1-.24-.67l7.78-16.5a.49.49,0,0,1,.66-.24.5.5,0,0,1,.24.67l-7.77,16.5A.51.51,0,0,1,363.33,255.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.9,257.1a.54.54,0,0,1-.21-.05.49.49,0,0,1-.24-.66l7.77-16.5a.5.5,0,0,1,.67-.24.5.5,0,0,1,.24.66l-7.78,16.5A.49.49,0,0,1,358.9,257.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.47,258.64a.59.59,0,0,1-.22-.05.51.51,0,0,1-.24-.67l7.78-16.5a.5.5,0,0,1,.66-.24.5.5,0,0,1,.24.67l-7.77,16.5A.51.51,0,0,1,354.47,258.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,260.17a.41.41,0,0,1-.21-.05.49.49,0,0,1-.24-.66l7.78-16.5a.5.5,0,0,1,.9.42l-7.77,16.5A.5.5,0,0,1,350,260.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.6,261.71a.54.54,0,0,1-.21,0,.5.5,0,0,1-.24-.67l7.77-16.5a.5.5,0,1,1,.91.43l-7.78,16.5A.49.49,0,0,1,345.6,261.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.62,158.5h-34.4a3.27,3.27,0,0,1-3.27-3.27V129a3.26,3.26,0,0,1,3.27-3.27h34.4a3.27,3.27,0,0,1,3.27,3.27v26.25A3.28,3.28,0,0,1,186.62,158.5Zm-34.4-31.79A2.27,2.27,0,0,0,150,129v26.25a2.27,2.27,0,0,0,2.27,2.27h34.4a2.27,2.27,0,0,0,2.27-2.27V129a2.27,2.27,0,0,0-2.27-2.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.09,193.14H109a3.27,3.27,0,0,1-3.27-3.27V145.28A3.27,3.27,0,0,1,109,142h49.07a3.28,3.28,0,0,1,3.27,3.27v44.59A3.28,3.28,0,0,1,158.09,193.14ZM109,143a2.27,2.27,0,0,0-2.27,2.27v44.59a2.27,2.27,0,0,0,2.27,2.27h49.07a2.27,2.27,0,0,0,2.27-2.27V145.28a2.27,2.27,0,0,0-2.27-2.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.08,
    y: 237.77,
    width: 54.9,
    height: 29.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,267.83H94.08a.5.5,0,0,1-.5-.5V237.77a.5.5,0,0,1,.5-.5H149a.5.5,0,0,1,.5.5v29.56A.5.5,0,0,1,149,267.83Zm-54.4-1h53.9V238.27H94.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.08,
    y: 262.01,
    width: 54.9,
    height: 5.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,267.83H94.08a.5.5,0,0,1-.5-.5V262a.5.5,0,0,1,.5-.5H149a.5.5,0,0,1,.5.5v5.32A.5.5,0,0,1,149,267.83Zm-54.4-1h53.9v-4.32H94.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.53,
    cy: 250.26,
    r: 8.87,
    transform: "translate(-156.22 266.14) rotate(-67.37)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.9 249.97 117.14 243.19 117.14 256.76 128.9 249.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.6,203.34H334.19a2.83,2.83,0,0,1-2.82-2.83v-61a2.83,2.83,0,0,1,2.82-2.83H416.6a2.83,2.83,0,0,1,2.82,2.83v61A2.83,2.83,0,0,1,416.6,203.34Zm-82.41-65.62a1.83,1.83,0,0,0-1.82,1.83v61a1.83,1.83,0,0,0,1.82,1.83H416.6a1.82,1.82,0,0,0,1.82-1.83v-61a1.82,1.82,0,0,0-1.82-1.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.91,
    y: 196.44,
    width: 81.73,
    height: 0.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.66,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.11,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.55,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.45,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.9,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.35,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.8,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.25,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.7,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.15,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.6,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.04,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.49,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.94,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.39,
    y: 196.69,
    width: 0.5,
    height: 1.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.63,195.71h76.29V185.17l-5.4-10.44a.88.88,0,0,1-.07-.23l-4.8-30.95a.58.58,0,0,0-1.16,0l-4.88,37.78a.74.74,0,0,1-.26.47l-4.7,3.64a.55.55,0,0,1-.84-.23l-4.74-9.78a.54.54,0,0,0-.95-.12l-4.9,6.32-5.45,7-5.44-7-4.81-6.19a.55.55,0,0,0-1,.22l-5.11,15.81L355,163.3l-5.45,31-5.45-4.22-4.31-12.25a.59.59,0,0,0-1.14.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.42,196.21H338.13V178.1a1.14,1.14,0,0,1,.92-1.17,1.06,1.06,0,0,1,1.19.74l4.26,12.11,4.68,3.62L355,160.55l5.59,28.94,4.51-14a1.11,1.11,0,0,1,.85-.77,1,1,0,0,1,1,.4l9.85,12.72,10-12.85a1.06,1.06,0,0,1,.94-.41,1.09,1.09,0,0,1,.85.62l4.74,9.78.39.45-.31-.39,4.71-3.65a.22.22,0,0,0,.06-.13L403,143.51a1.11,1.11,0,0,1,1.07-1h0a1.1,1.1,0,0,1,1.08,1l4.79,30.95,5.48,10.63Zm-76.29-1h75.29v-9.92L409.08,175a1.29,1.29,0,0,1-.12-.38l-4.8-31c0-.07,0-.14-.09-.14s-.07,0-.08.15l-4.88,37.78a1.27,1.27,0,0,1-.45.8l-4.7,3.64a1,1,0,0,1-.87.19,1.12,1.12,0,0,1-.73-.6l-4.74-9.78-.5-.34.4.31L376.77,189.5l-10.64-13.73c-.06,0-.09,0-.12.06l-5.7,17.67L355,166.06l-5.12,29.15-6.22-4.82L339.29,178s0-.09-.07-.09-.09.06-.09.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,195.73H338.63v-9.07l5.39-9a.56.56,0,0,0,.08-.2l4.8-26.62a.59.59,0,0,1,1.16,0l4.88,32.49a.55.55,0,0,0,.26.4l4.7,3.13a.59.59,0,0,0,.84-.2l4.73-8.4a.59.59,0,0,1,.95-.11l4.91,5.44,5.44,6,5.45-6,4.8-5.33a.59.59,0,0,1,1,.19l5.11,13.6h5.45l5.45,2.42,5.45-3.63,4.31-10.53a.59.59,0,0,1,1.14.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,146.48H379.94a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.89a.5.5,0,0,1,.5.5A.51.51,0,0,1,396.83,146.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,150.43H379.94a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.89a.5.5,0,0,1,.5.5A.51.51,0,0,1,396.83,150.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,154.38H379.94a.5.5,0,1,1,0-1h16.89a.5.5,0,1,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,158.33H379.94a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h16.89a.51.51,0,0,1,.5.5A.5.5,0,0,1,396.83,158.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,162.29H379.94a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.89a.5.5,0,0,1,.5.5A.51.51,0,0,1,396.83,162.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,166.24H379.94a.5.5,0,0,1,0-1h16.89a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,146.48h-2.11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.11a.5.5,0,0,1,.5.5A.51.51,0,0,1,378.22,146.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,150.43h-2.11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.11a.5.5,0,0,1,.5.5A.51.51,0,0,1,378.22,150.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,154.38h-2.11a.5.5,0,0,1,0-1h2.11a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,158.33h-2.11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.11a.51.51,0,0,1,.5.5A.5.5,0,0,1,378.22,158.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,162.29h-2.11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.11a.5.5,0,0,1,.5.5A.51.51,0,0,1,378.22,162.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,166.24h-2.11a.5.5,0,0,1,0-1h2.11a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "137.78 350.59 108.22 350.59 108.22 310.99 128.98 310.99 137.78 319.06 137.78 350.59"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "139.51 349.25 109.95 349.25 109.95 309.65 130.71 309.65 139.51 317.72 139.51 349.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.51,349.75H110a.5.5,0,0,1-.5-.5v-39.6a.5.5,0,0,1,.5-.5h20.76a.49.49,0,0,1,.34.14l8.8,8.06a.52.52,0,0,1,.16.37v31.53A.5.5,0,0,1,139.51,349.75Zm-29.06-1H139V317.94l-8.49-7.79H110.45Z",
    style: {
      fill: "#263238"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "130.71 309.65 128.55 319.13 139.51 317.72 130.71 309.65"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.55,319.63a.5.5,0,0,1-.37-.17.52.52,0,0,1-.12-.45l2.16-9.47a.5.5,0,0,1,.83-.25l8.8,8.06a.5.5,0,0,1-.28.87l-11,1.4Zm2.46-9-1.81,7.94,9.18-1.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.71 309.65 130.71 317.72 139.51 317.72 130.71 309.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.51,318.22h-8.8a.5.5,0,0,1-.5-.5v-8.07a.5.5,0,0,1,.3-.45.49.49,0,0,1,.54.09l8.8,8.06a.5.5,0,0,1-.34.87Zm-8.3-1h7l-7-6.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,324H115.61a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.85a.51.51,0,0,1,.5.5A.5.5,0,0,1,132.46,324Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,328.17H115.61a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.85a.51.51,0,0,1,.5.5A.5.5,0,0,1,132.46,328.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,332.3H115.61a.5.5,0,0,1,0-1h16.85a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,336.43H115.61a.5.5,0,0,1,0-1h16.85a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,340.56H115.61a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.85a.5.5,0,0,1,.5.5A.51.51,0,0,1,132.46,340.56Z",
    style: {
      fill: "#263238"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.2 363.96 128.63 363.96 128.63 324.36 149.4 324.36 158.2 332.43 158.2 363.96"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "159.92 362.63 130.36 362.63 130.36 323.03 151.12 323.03 159.92 331.09 159.92 362.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,363.13H130.36a.5.5,0,0,1-.5-.5V323a.5.5,0,0,1,.5-.5h20.76a.47.47,0,0,1,.34.13l8.8,8.06a.52.52,0,0,1,.16.37v31.54A.5.5,0,0,1,159.92,363.13Zm-29.06-1h28.56V331.31l-8.49-7.78H130.86Z",
    style: {
      fill: "#263238"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "151.12 323.03 148.96 332.5 159.92 331.09 151.12 323.03"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149,333a.5.5,0,0,1-.37-.17.5.5,0,0,1-.12-.44l2.16-9.47a.49.49,0,0,1,.34-.37.51.51,0,0,1,.49.11l8.8,8.06a.5.5,0,0,1-.27.87L149,333Zm2.46-9-1.81,7.93,9.18-1.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.12 323.03 151.12 331.09 159.92 331.09 151.12 323.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,331.59h-8.8a.5.5,0,0,1-.5-.5V323a.51.51,0,0,1,.3-.46.49.49,0,0,1,.54.09l8.8,8.06a.51.51,0,0,1,.13.55A.5.5,0,0,1,159.92,331.59Zm-8.3-1h7l-7-6.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,337.42H136a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.85a.5.5,0,0,1,.5.5A.5.5,0,0,1,152.87,337.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,341.54H136a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.85a.5.5,0,0,1,.5.5A.5.5,0,0,1,152.87,341.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,345.67H136a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.85a.5.5,0,0,1,.5.5A.5.5,0,0,1,152.87,345.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,349.8H136a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.85a.5.5,0,0,1,.5.5A.5.5,0,0,1,152.87,349.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,353.93H136a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.85a.5.5,0,0,1,.5.5A.5.5,0,0,1,152.87,353.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,390.33a.5.5,0,0,1-.5-.5V321.07a.47.47,0,0,1,.15-.35l15.26-15.27V281.56a.5.5,0,0,1,1,0v24.1a.47.47,0,0,1-.15.35l-15.26,15.27v68.55A.5.5,0,0,1,363,390.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,387.17a.5.5,0,0,1-.5-.5V344.78a.51.51,0,0,1,.15-.35l11.31-11.31V321.86a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v11.46a.52.52,0,0,1-.14.36L373.73,345v41.68A.5.5,0,0,1,373.23,387.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.31,393.49a.5.5,0,0,1-.5-.5V285.51a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V393A.5.5,0,0,1,350.31,393.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.9,286.15a2.5,2.5,0,1,0-2.5,2.5A2.49,2.49,0,0,0,352.9,286.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.78,281.66a2.5,2.5,0,1,0-2.5,2.49A2.5,2.5,0,0,0,380.78,281.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.2,320.79a2.5,2.5,0,1,0-2.5,2.5A2.5,2.5,0,0,0,387.2,320.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438,440.46H69a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H438a.5.5,0,0,1,.5.5A.5.5,0,0,1,438,440.46Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ffae51ca407929f2a53f47806df355a7.svg";
export { ForwardRef as ReactComponent };